import React from "react";
import { CollapsePanel } from "./CollapsePanel";

export const AccumulatorDetails = ({ biInfo, noMoopProvided }) => {
  const productBenefits = biInfo?.productBenefits;
  if (!productBenefits?.length) return null;

  return (
    <CollapsePanel labelText="Accumulator Details">
      {productBenefits.map((benefit, index) => {
        const accumulatorDetail = benefit?.in_net_and_out_net_accumulator_values;
        if (!accumulatorDetail) return null;

        const productNames = getProductNamesWithCodes(benefit.products);

        return (
          <div key={index} className="mb-4">
            <h6 className="text-muted fw-semibold fs-5 mb-2">Associated Products</h6>
            <ul className="list-inline bg-info bg-opacity-10 rounded p-3 mb-3" id={`product${index + 1}-associated-products`}>
              {productNames.map((name, productIndex) => (
                <li key={productIndex} className="list-inline-item text-muted fw-semibold fs-5 me-3">
                  <span className="me-1">&bull;</span>
                  {name}
                </li>
              ))}
            </ul>
            <div className="table-responsive p-0">
              <table className="table table-borderless rounded mb-0">
                <thead>
                  <tr>
                    <th className="col-6 pb-2 p-0" />
                    <th className="text-muted fw-semibold fs-5 text-end pb-2 p-0">IN Network</th>
                    <th className="text-muted fw-semibold fs-5 text-end pb-2 p-0">Out of Network</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Deductible Remaining</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_deductible_remaining`}>
                      {accumulatorDetail.in_net_deductible_remaining}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_deductible_remaining`}>
                      {accumulatorDetail.out_net_deductible_remaining}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Deductible Total</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_deductible_total`}>
                      {accumulatorDetail.in_net_deductible_total}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_deductible_total`}>
                      {accumulatorDetail.out_net_deductible_total}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Max out of Pocket Remaining</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_max_out_of_pocket_remaining`}>
                      {noMoopProvided || accumulatorDetail.in_net_max_out_of_pocket_remaining == null
                        ? "NA"
                        : accumulatorDetail.in_net_max_out_of_pocket_remaining}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_max_out_of_pocket_remaining`}>
                      {accumulatorDetail.out_net_max_out_of_pocket_remaining}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Max out of Pocket Total</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_max_out_of_pocket_total`}>
                      {accumulatorDetail.in_net_max_out_of_pocket_total}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_max_out_of_pocket_total`}>
                      {accumulatorDetail.out_net_max_out_of_pocket_total}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Coinsurance</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_coinsurance`}>
                      {accumulatorDetail.in_net_coinsurance}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_coinsurance`}>
                      {accumulatorDetail.out_net_coinsurance}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-muted fw-semibold p-2 fs-5">Copay</td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-in_net_copay`}>
                      {accumulatorDetail.in_net_copay}
                    </td>
                    <td className="text-end p-2 fs-5" id={`product${index + 1}-out_net_copay`}>
                      {accumulatorDetail.out_net_copay}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        );
      })}
    </CollapsePanel>
  );
};

/**
 * Returns an array with one entry per product, listing its procedure codes
 * comma-separated in parentheses, e.g. ["Product A (123, 456)", "Product B (789)"].
 * Products with no procedure codes are returned as just the name.
 */
const getProductNamesWithCodes = (products = []) =>
  products.map((product) => {
    const codes = (product?.procedureCodes || []).map(({ code }) => code).join(", ");
    return codes ? `${product.productName} (${codes})` : product.productName;
  });
